package com.example.mystybag.login.views

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.views.AppTheme
import dev.icerock.moko.resources.compose.stringResource

@Composable
actual fun AuthDesktopScreen(content: @Composable () -> Unit) {
    val colors = AppTheme.current.colors
    Row(
        modifier = Modifier
            .fillMaxSize()
            .background(colors.background)
    ) {
        Column(
            modifier = Modifier
                .fillMaxHeight()
                .weight(1f)
                .background(colors.surfaceContainerLow)
                .padding(horizontal = 48.dp, vertical = 40.dp),
            horizontalAlignment = Alignment.Start,
            verticalArrangement = Arrangement.spacedBy(16.dp)
        ) {
            Texts.HeadlineSmall(text = "MystyBag", color = colors.onSurface)
            Texts.BodyLarge(
                text = stringResource(SR.strings.what_kind_of_user_are_you),
                color = colors.onSurfaceVariant
            )
        }

        Box(
            modifier = Modifier
                .fillMaxHeight()
                .weight(1f)
                .background(colors.surface),
            contentAlignment = Alignment.TopStart
        ) {
            content()
        }
    }
}

actual fun Modifier.authScreenContentWidth(): Modifier =
    this
        .fillMaxWidth()
        .fillMaxHeight()
